<template>
  <div id="settings-layout">
    <div class="settings-layout-container">
      <div class="sidebar p-2 card">
        <router-link
          to="/settings/account-settings"
          class="sidebar-item"
          :class="{
            active: currentRoute.startsWith('/settings/account-settings')
          }"
        >
          {{ $t('settings.accountSettings.title') }}
        </router-link>
        <router-link
          to="/settings/call-settings"
          class="sidebar-item"
          :class="{
            active: currentRoute.startsWith('/settings/call-settings')
          }"
        >
          {{ $t('settings.callSettings.title') }}
        </router-link>
      </div>
      <div class="flex-fill">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsLayout',
  computed: {
    currentRoute() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.settings-layout-container {
  display: flex;
  gap: 0.5rem;
}
.sidebar-item {
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  &.active {
    font-weight: bold;
    background-color: #f0f0f0;
  }
}
</style>
